import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminGuard } from '../shared/services/admin.guard';
import { AuthGuard } from '../shared/services/auth.guard';
import { AiEnabledGuard } from '../shared/services/ai-enabled.guard';
import { LegacyWalletRedirectGuard } from '../shared/services/legacy-wallet-redirect.guard';
import { AffiliatesComponent } from './affiliates/affiliates.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { AnalyticsCampaignsComponent } from './analytics/campaigns/campaigns.component';
import { AnalyticsCampaignsDetailsComponent } from './analytics/campaigns/detail/detail.component';
import { AnalyticsSalesComponent } from './analytics/sales/sales.component';
import { BroadcastsFilterComponent } from './broadcasts-filter/broadcasts-filter.component';
import { BroadcastWhatsappComponent } from './broadcasts-whatsapp/broadcast-whatsapp/broadcast-whatsapp.component';
import { BroadcastsWhatsappComponent } from './broadcasts-whatsapp/broadcasts-whatsapp.component';
import { ViewBroadcastWhatsappComponent } from './broadcasts-whatsapp/view-broadcast-whatsapp/view-broadcast-whatsapp.component';
import { BroadcastComponent } from './broadcasts/broadcast/broadcast.component';
import { BroadcastsComponent } from './broadcasts/broadcasts.component';
import { IntegrationSmsComponent } from './integration-sms/integration-sms.component';
import { ViewIntegrationSmsComponent } from './integration-sms/view-integration-sms/view-integration-sms.component';
import { IntegrationSmsSendsComponent } from './integration-sms/integration-sms-sends/integration-sms-sends.component';
import { ViewBroadcastComponent } from './broadcasts/view-broadcast/view-broadcast.component';
import { CampaignComponent } from './campaigns/campaign/campaign.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountConfirmationComponent } from './account-confirmation/account-confirmation.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HelpComponent } from './help/help.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { PostbacksComponent } from './integrations/postbacks/postbacks.component';
import { IntegrationActivityComponent } from './integrations/activity/activity.component';
import { LayoutComponent } from './layout/layout.component';
import { SignUpSuccessComponent } from './layout/sign-up/sign-up-success/sign-up-success.component';
import { SignUpComponent } from './layout/sign-up/sign-up.component';
import { LeadResponsesComponent } from './lead-responses/lead-responses.component';
import { LeadPostbackComponent } from './leads/lead-postback/lead-postback.component';
import { LeadSequencesComponent } from './leads/lead-sequences/lead-sequences.component';
import { ListComponent } from './lists/list/list.component';
import { ListsComponent } from './lists/lists.component';
import { LoginComponent } from './login/login.component';
import { MessagesReportComponent } from './messages-report/messages-report.component';
import { MessagesComponent } from './messages-report/messages/messages.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { PartnerDashboardComponent } from './partner-dashboard/partner-dashboard.component';
import { PartnerManagementComponent } from './partner-management/partner-management.component';
import { PartnerPaymentsComponent } from './partner-payments/partner-payments.component';
import { PasswordResetStartComponent } from './password-reset-start/password-reset-start.component';
import { PasswordResetSuccessComponent } from './password-reset-success/password-reset-success.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { InviteAcceptComponent } from './invite-accept/invite-accept.component';
import { AccountOwnerGuard } from '../shared/services/account-owner.guard';
import { ProfileComponent } from './profile/profile.component';
import { ProviderComponent } from './providers/providers.component';
import { AddCreditsComponent } from './recharges/add-credits/add-credits.component';
import { DominioProprioComponent } from './dominio-proprio/dominio-proprio.component';
import { DominioPrecosComponent } from './dominio-proprio/precos/dominio-precos.component';
import { RechargeComponent } from './recharges/recharge/recharge.component';
import { RechargesComponent } from './recharges/recharges.component';
import { ReportsComponent } from './reports/reports.component';
import { ShortUrlAnalysisComponent } from './short-url-analysis/short-url-analysis.component';
import { FunnelPerformanceComponent } from './analytics/funnel-performance/funnel-performance.component';
import { AiOrWhatsappEnabledGuard } from '../shared/services/ai-or-whatsapp-enabled.guard';
import { RcsEnabledGuard } from '../shared/services/rcs-enabled.guard';
import { FractionationsComponent } from './fractionations/fractionations.component';
import { FractionationComponent } from './fractionations/fractionation/fractionation.component';
import { ProviderReportComponent } from './provider-report/provider-report.component';
import { AppAuthenticationReportComponent } from './app-authentication-report/app-authentication-report.component';
import { AuditLogsComponent } from './audit-logs/audit-logs.component';

import { SmsValidationComponent } from './sms-validation/sms-validation.component';

import { SupportFormComponent } from './support-form/support-form.component';
import { UserComponent } from './users/user/user.component';
import { UsersComponent } from './users/users.component';
import { ViewPartnerPaymentsComponent } from './view-partner-payments/view-partner-payments.component';
import { ConsumptionReport } from './consumption-report/consumption-report.component';
import { FinancialComponent } from './financial/financial.component';
import { RedirectSignupComponentComponent } from './redirect-signup-component/redirect-signup-component.component';
import { TutoriaisComponent } from './tutoriais/tutoriais.component';
import { ApiComponent } from '../api/api.component';
import { PartnerStatisticsComponent } from './partner-statistics/partner-statistics.component';
import { PlatformAppMiddleware } from '../shared/middlewares/platform-app.middleware';
import { Call4uAudiosComponent } from './call4u-audios/call4u-audios.component';
import { Call4uAudioCreateComponent } from './call4u-audios/call4u-audio-create/call4u-audio-create.component';
import { Call4uAudioEditComponent } from './call4u-audios/call4u-audio-edit/call4u-audio-edit.component';
import { BroadcastsCallComponent } from './broadcasts-call/broadcasts-call.component';
import { BroadcastCallComponent } from './broadcasts-call/broadcast-call/broadcast-call.component';
import { ViewBroadcastCallComponent } from './broadcasts-call/view-broadcast-call/view-broadcast-call.component';
import { EditBroadcastCallComponent } from './broadcasts-call/edit-broadcast-call/edit-broadcast-call.component';
import { LigacoesMetricasComponent } from './ligacoes-metricas/ligacoes-metricas.component';
import { CallsReportComponent } from './calls-report/calls-report.component';
import { CallsComponent } from './calls-report/calls/calls.component';
import { IntegrationProposerGuard } from '../shared/guards/integration-proposer.guard';
import { IntegrationTemplatesComponent } from './integrations-templates/integrations-templates.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [AuthGuard],
    canActivate: [PlatformAppMiddleware],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'affiliates', component: AffiliatesComponent },
      {
        path: 'broadcasts',
        children: [
          { path: '', component: BroadcastsComponent },
          { path: 'new', component: BroadcastComponent },
          { path: ':id', component: BroadcastComponent },
          { path: 'view/:id', component: ViewBroadcastComponent },
        ],
      },
      {
        path: 'integration-sms',
        children: [
          { path: '', component: IntegrationSmsComponent },
          { path: 'view/:source', component: ViewIntegrationSmsComponent },
          { path: 'view/:source/sends', component: IntegrationSmsSendsComponent },
        ],
      },
      {
        path: 'provider',
        children: [{ path: '', component: ProviderComponent }],
      },
      {
        path: 'conversations',
        canActivate: [AiOrWhatsappEnabledGuard],
        loadChildren: () => import('./conversations/conversations.module').then(m => m.ConversationsModule)
      },
      {
        path: 'broadcasts-whatsapp',
        children: [
          { path: '', component: BroadcastsWhatsappComponent },
          { path: 'new', component: BroadcastWhatsappComponent },
          { path: ':id', component: BroadcastWhatsappComponent },
          { path: 'view/:id', component: ViewBroadcastWhatsappComponent },
        ],
      },
      { path: 'sms-validation', component: SmsValidationComponent },
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'campaigns',
        children: [
          { path: '', component: CampaignsComponent },
          { path: 'new', component: CampaignComponent },
          { path: 'edit/:id', component: CampaignComponent },
        ],
      },
      { path: 'change-password', component: ChangePasswordComponent },

      { path: 'help', component: HelpComponent },
      {
        path: 'integrations',
        children: [
          { path: '', component: IntegrationsComponent },
          { path: ':id/postbacks', component: PostbacksComponent },
          { path: ':id/activity', component: IntegrationActivityComponent },
        ],
      },
      {
        path: 'lead',
        children: [
          { path: ':id/sequences', component: LeadSequencesComponent },
          { path: ':id/postback', component: LeadPostbackComponent },
        ],
      },
      {
        // M7 (17tm466nz8b): o guard redireciona para Relatórios quando o cliente migrou
        // (GET /wallet/navigation.hide.lead_responses) — a tela continua existindo para
        // quem não migrou, já que "Respostas recebidas" não tem relatório equivalente ainda.
        path: 'lead-responses',
        component: LeadResponsesComponent,
        canActivate: [LegacyWalletRedirectGuard],
        data: { legacyWalletScreen: 'responses' },
      },
      {
        path: 'lists',
        children: [
          { path: '', component: ListsComponent },
          { path: 'new', component: ListComponent },
          { path: 'edit/:id', component: ListComponent },
        ],
      },
      {
        // M7 (17tm466nz8b): hide.messages_report → Relatórios › Disparos › SMS, já filtrado
        // pelo mês/dia que a tela antiga mostrava.
        path: 'messages-report',
        children: [
          { path: '', component: MessagesReportComponent, canActivate: [LegacyWalletRedirectGuard], data: { legacyWalletScreen: 'messages' } },
          { path: ':date', component: MessagesComponent, canActivate: [LegacyWalletRedirectGuard], data: { legacyWalletScreen: 'messages' } },
        ],
      },
      {
        path: 'partner',
        children: [
          { path: '', component: PartnerDashboardComponent },
          { path: 'payments', component: PartnerPaymentsComponent },
          { path: 'statistics/:userId', component: PartnerStatisticsComponent }
        ]
      },
      {
        path: 'partner-management',
        children: [
          { path: '', component: PartnerManagementComponent },
          { path: ':id/payments', component: ViewPartnerPaymentsComponent },
        ],
      },
      {
        path: 'profile',
        children: [
          { path: '', component: ProfileComponent },
          // Token da API de Parceiros é do proprietário (CU-17tm466h1cm).
          { path: 'api', component: ApiComponent, canActivate: [AccountOwnerGuard] },
        ],
      },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'financial', component: FinancialComponent },

      {
        // M7 (17tm466nz8b): hide.recharges → Relatórios › Recargas; "new" vai para o modal de
        // recarga por valor na própria Minha Carteira (`?recarga=1`), não para o relatório.
        // `add`/`add/:userId` são do admin (lançar crédito em nome do cliente) — nunca redirecionam.
        path: 'recharges',
        children: [
          { path: '', component: RechargesComponent, canActivate: [LegacyWalletRedirectGuard], data: { legacyWalletScreen: 'recharges' } },
          { path: 'new', component: RechargeComponent, canActivate: [LegacyWalletRedirectGuard], data: { legacyWalletScreen: 'recharges-new' } },
          { path: 'add', component: AddCreditsComponent },
          { path: 'add/:userId', component: AddCreditsComponent },
          { path: 'edit/:id', component: RechargeComponent, canActivate: [LegacyWalletRedirectGuard], data: { legacyWalletScreen: 'recharges' } },
        ],
      },
      { path: 'dominio-proprio', component: DominioProprioComponent },
      { path: 'dominio-proprio/precos', component: DominioPrecosComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'support', component: SupportFormComponent },
      { path: 'tutoriais', component: TutoriaisComponent },
      {
        path: 'users',
        children: [
          { path: '', component: UsersComponent },
          { path: 'new', component: UserComponent },
          { path: 'edit/:id', component: UserComponent },
        ],
      },
      {
        path: 'short-url-analysis',
        component: ShortUrlAnalysisComponent,
      },
      {
        path: 'broadcasts-filter',
        component: BroadcastsFilterComponent,
      },
      {
        path: 'analytics',
        children: [
          { path: '', component: AnalyticsComponent },
          { path: 'campaigns', component: AnalyticsCampaignsComponent },
          {
            path: 'campaigns/:id',
            component: AnalyticsCampaignsDetailsComponent,
          },
          { path: 'sales', component: AnalyticsSalesComponent },
          { path: 'funnel-performance', component: FunnelPerformanceComponent },
        ],
      },
      {
        path: 'consumption-report',
        component: ConsumptionReport,
      },
      {
        path: 'fractionations',
        children: [
          { path: '', component: FractionationsComponent },
          { path: ':id', component: FractionationComponent },
        ],
      },
      {
        path: 'call4u-audios', children: [
          { path: '', component: Call4uAudiosComponent },
          { path: 'new', component: Call4uAudioCreateComponent },
          { path: 'edit/:id', component: Call4uAudioEditComponent },
        ]
      },
      {
        path: 'broadcasts-call', children: [
          { path: '', component: BroadcastsCallComponent },
          { path: 'new', component: BroadcastCallComponent },
          { path: 'view/:id', component: ViewBroadcastCallComponent },
          { path: 'edit/:id', component: EditBroadcastCallComponent },
        ]
      },
      { path: 'ligacoes-metricas', component: LigacoesMetricasComponent },
      {
        path: 'calls-report', children: [
          { path: '', component: CallsReportComponent },
          { path: ':date', component: CallsComponent }
        ]
      },
      { path: 'provider-report', component: ProviderReportComponent },
      { path: 'app-authentication-report', component: AppAuthenticationReportComponent },
      {
        path: 'playground-ia',
        canActivate: [AiEnabledGuard],
        canActivateChild: [AiEnabledGuard],
        loadChildren: () => import('./playground-ia/playground-ia.module').then(m => m.PlaygroundIaModule)
      },
      {
        path: 'whatsapp-integration',
        canActivate: [AiOrWhatsappEnabledGuard],
        canActivateChild: [AiOrWhatsappEnabledGuard],
        loadChildren: () => import('./whatsapp-integration/whatsapp-integration.module').then(m => m.WhatsappIntegrationModule)
      },
      {
        // RCS (17tm466frtx). Módulo próprio sob `admin/rcs`, e não filho do `AdminAiModule`:
        // o módulo de IA é de outra seção do Admin. Fica antes de `admin` para o roteador
        // casar o prefixo mais específico primeiro, sem depender de retrocesso.
        path: 'admin/rcs',
        loadChildren: () => import('./admin-rcs/admin-rcs.module').then(m => m.AdminRcsModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin-ai/admin-ai.module').then(m => m.AdminAiModule)
      },
      {
        path: 'integrations/platform',
        component: IntegrationTemplatesComponent,
        canActivate: [IntegrationProposerGuard],
      },
      {
        path: 'admin-configurations',
        loadChildren: () => import('./admin-configurations/admin-configurations.module').then(m => m.AdminConfigurationsModule)
      },
      {
        path: 'admin-pricing',
        loadChildren: () => import('./admin-pricing/admin-pricing.module').then(m => m.AdminPricingModule)
      },
      {
        path: 'wallet',
        loadChildren: () => import('./wallet/wallet.module').then(m => m.WalletModule)
      },
      {
        // Canal RCS do cliente (17tm466frtx): agentes, galeria, envio em massa e relatório.
        path: 'rcs',
        canActivate: [RcsEnabledGuard],
        canActivateChild: [RcsEnabledGuard],
        loadChildren: () => import('./rcs/rcs.module').then(m => m.RcsModule)
      },
      { path: 'audit-logs', component: AuditLogsComponent, canActivate: [AdminGuard] },

    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'password-reset', component: PasswordResetStartComponent },
  { path: 'password-reset/:hash', component: PasswordResetComponent },
  { path: 'password-reset-success', component: PasswordResetSuccessComponent },
  // Multiusuários (CU-17tm466h1cm): link do e-mail de convite, sem sessão.
  { path: 'invite/:token', component: InviteAcceptComponent },
  { path: 'sign-up', component: RedirectSignupComponentComponent },
  { path: 'sign-up/success', component: SignUpSuccessComponent },
  { path: 'sign-up/:code', component: RedirectSignupComponentComponent },
  { path: 'account-confirmation', component: AccountConfirmationComponent },
  {
    // Página pública do Pix do RCS (D2): quem abre é o destinatário da mensagem,
    // sem conta no painel. Fora do `LayoutComponent` e sem guarda de login.
    path: 'pix/:token',
    loadComponent: () => import('./pix-copy/pix-copy.component').then(m => m.PixCopyComponent)
  },
  {
    path: '**',
    component: LayoutComponent,
    children: [{ path: '', component: NotFoundComponent }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
